import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import Slider from "react-slick";
import "./EventDetails.css";

const EventDetails = () => {
    const location = useLocation();

    // FIXED: Strictly load data received from previous page state stream, no background recovery APIs allowed
    const event = location.state?.event || null;

    const [selectedIndex, setSelectedIndex] = useState(null);

    // Extract gallery files safely from passed token object maps
    const galleryImages = (event?.gallery_images || [])
        .map(img => img?.image_url)
        .filter(url => url && url !== null && url !== "null");

    // Humanize standard database datetime layouts safely (e.g. "2026-06-02 00:00:00")
    const formatCustomLongDate = (rawString) => {
        if (!rawString) return "";
        try {
            const dateObj = new Date(rawString.replace(/-/g, "/"));
            if (isNaN(dateObj.getTime())) return rawString.split(" ")[0];
            return dateObj.toLocaleDateString("en-US", {
                weekday: "long",
                day: "numeric",
                month: "short",
                year: "numeric"
            });
        } catch (e) {
            return rawString;
        }
    };

    // Humanize standard operational clock settings safely (e.g. "10:00:00")
    const formatTimeTwelveHour = (timeString) => {
        if (!timeString) return "";
        try {
            const [hours, minutes] = timeString.split(":");
            const hourNum = parseInt(hours, 10);
            const ampm = hourNum >= 12 ? "PM" : "AM";
            const processedHour = hourNum % 12 || 12;
            return `${processedHour}:${minutes} ${ampm}`;
        } catch (e) {
            return timeString;
        }
    };

    const nextImage = (e) => {
        e.stopPropagation();
        setSelectedIndex((prev) =>
            prev === galleryImages.length - 1 ? 0 : prev + 1
        );
    };

    const prevImage = (e) => {
        e.stopPropagation();
        setSelectedIndex((prev) =>
            prev === 0 ? galleryImages.length - 1 : prev - 1
        );
    };

    const photoGallery_slider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                },
            },
        ],
    };

    // FIXED: Instant error handling view if the required state mapping object is missing
    if (!event) {
        return (
            <div className="container py-5 my-5 text-center">
                <div className="alert alert-danger p-4 mx-auto" style={{ maxWidth: "500px" }}>
                    <h4>⚠️ Event Transfer Missing</h4>
                    <p className="mb-3">No event context records were passed to this layout viewport.</p>
                    <Link to="/Events" className="btn next-btn btn-sm text-white px-4">Back to Events Grid</Link>
                </div>
            </div>
    );
    }

    return (
        <>
            <main className="main_wrapper">
                <section>
                    <div className="container">
                        <div className="tab-content-box">
                            <div className="profile-wrapper">

                                {/* Top Information Section */}
                                <div className="row">

                                    {/* Profile Image Banner Card */}
                                    <div className="col-lg-6 mb-5">
                                        <div className="info-card">
                                            <div className="profile-image-box">
                                                <img
                                                      src={event.image_url || "/assets/imgs/event_default_img.png"}
                                                    alt={event.title}
                                                    className="main-profile-img"
                                                    onError={(e) => { e.target.src = "assets/imgs/event_default_img.png"; }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Event Meta Configuration Properties Details */}
                                    <div className="col-lg-6 mb-5">
                                        <div className="info-card h-100">
                                            <h4 className="profile-heading">Event Information</h4>

                                            <div className="contact_details border-0">
                                                <div className="c_icon">
                                                    <i className="fa-solid fa-mobile-screen"></i>
                                                </div>
                                                <div className="con_d">
                                                    <h5>Date:<br /> <span>{formatCustomLongDate(event.start_date) || "Scheduled"}</span></h5>
                                                </div>
                                            </div>

                                            <div className="contact_details">
                                                <div className="c_icon">
                                                    <i className="fa-regular fa-envelope"></i>
                                                </div>
                                                <div className="con_d">
                                                    <h5>Time:<br /> <span>{formatTimeTwelveHour(event.start_time) || "To Be Announced"}</span></h5>
                                                </div>
                                            </div>

                                            <div className="contact_details">
                                                <div className="c_icon">
                                                    <i className="fa-solid fa-location-dot"></i>
                                                </div>
                                                <div className="con_d">
                                                    <h5>Address:<br /> <span>{event.location}</span></h5>
                                                </div>
                                            </div>

                                            {event.price && parseFloat(event.price) > 0 && (
                                                <div className="contact_details">
                                                    <div className="c_icon">
                                                        <i className="fa-solid fa-indian-rupee-sign"></i>
                                                    </div>
                                                    <div className="con_d">
                                                        <h5>Entry Registration Price:<br /> <span className="text-danger fw-bold">INR {parseFloat(event.price)}/-</span></h5>
                                                    </div>
                                                </div>
                                                )}
                                        </div>
                                    </div>
                                </div>

                                {/* Description Paragraph Blocks */}
                                <div className="mb-5">
                                    <h4 className="profile-heading">About {event.title}</h4>
                                    <p className="partner-text" style={{ whiteSpace: "pre-line", lineHeight: "1.8" }}>
                                        {event.description}
                                    </p>
                                </div>

                                {/* Dynamic Slick Photo Gallery Module Block Loop */}
                                {/* {galleryImages.length > 0 && (
                                    <div className="mt-4">
                                        <h4 className="profile-heading mb-4">Photo Gallery</h4>
                                        <Slider className="event-wrapper" {...photoGallery_slider}>
                                            {galleryImages.map((imgUrl, index) => (
                                                <div className="event_img" key={index}>
                                                    <img
                                                        src={imgUrl}
                                                        alt={`Gallery Item ${index + 1}`}
                                                        onClick={() => setSelectedIndex(index)}
                                                        style={{
                                                            width: "100%",
                                                            cursor: "pointer",
                                                            borderRadius: "10px",
                                                            objectFit: "cover",
                                                            height: "150px"
                                                        }}
                                                        onError={(e) => { e.target.style.display = "none"; }}
                                                    />
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                    )} */}


                                    {/* Dynamic Slick Photo & Video Gallery */}
{galleryImages.length > 0 && (
    <div className="mt-4">
        <h4 className="profile-heading mb-4">Photo Gallery</h4>

        <Slider className="event-wrapper" {...photoGallery_slider}>
            {galleryImages.map((fileUrl, index) => {
                const isVideo = /\.(mp4|webm|ogg|mov)$/i.test(fileUrl);

                return (
                    <div className="event_img" key={index}>
                        {isVideo ? (
                            <div
                                className="gallery-video-wrapper"
                                onClick={() => setSelectedIndex(index)}
                            >
                                <video
                                    src={fileUrl}
                                    muted
                                    preload="metadata"
                                    className="gallery-thumb"
                                />
                                <span className="gallery-play-icon">▶</span>
                            </div>
                        ) : (
                            <img
                                src={fileUrl}
                                alt={`Gallery Item ${index + 1}`}
                                onClick={() => setSelectedIndex(index)}
                                className="gallery-thumb"
                                onError={(e) => {
                                    e.target.style.display = "none";
                                }}
                            />
                        )}
                    </div>
                );
            })}
        </Slider>
    </div>
)}

                            </div>
                        </div>
                    </div>
                </section>

                {/* Lightbox Popover Viewport Modal */}
{selectedIndex !== null && (
    <div
        className="image_modal"
        onClick={() => setSelectedIndex(null)}
    >
        <div
            className="modal_content"
            onClick={(e) => e.stopPropagation()}
        >
            {/* Previous Button */}
            <button className="nav_btn prev_btn" onClick={prevImage}>
                ❮
            </button>

            {/* Main Media Display */}
            {/\.(mp4|webm|ogg|mov)$/i.test(galleryImages[selectedIndex]) ? (
                <video
                    src={galleryImages[selectedIndex]}
                    controls
                    autoPlay
                    className="modal_media"
                />
            ) : (
                <img
                    src={galleryImages[selectedIndex]}
                    alt="Enlarged Selection"
                    className="modal_media"
                />
            )}

            {/* Next Button */}
            <button className="nav_btn next_btn" onClick={nextImage}>
                ❯
            </button>

            {/* Close Button */}
            <button
                className="close_btn"
                onClick={() => setSelectedIndex(null)}
            >
                ✕
            </button>
        </div>
    </div>
)}
            </main>
        </> 
    );
};

export default EventDetails; 